import { t } from '@/shared/lib/i18n'
import { cn } from '@/shared/lib/utils'
import {
  RICH_TEXT_DISPLAY_CLASSNAME,
  richTextToPlainText,
  sanitizeRichTextHtml,
} from '@/shared/lib/rich-text-html'

// Lot notes are authored through RichTextEditor, so the stored value is HTML. Printing it as a
// plain React child rendered the markup verbatim ("<p>Open Stability = 90 days</p>"), so sanitize
// and render it the same way comments do. Visibility is decided on the plain-text projection so an
// empty-but-not-blank value ("<p></p>") no longer paints an empty banner.
export const LotNotesBanner = ({
  notes,
  className,
}: {
  notes: string | null | undefined
  className?: string
}) => {
  const notesHtmlSource = notes ?? ''
  if (richTextToPlainText(notesHtmlSource).length === 0) return null

  return (
    <div
      className={cn('rounded border border-yellow-200 bg-yellow-50 px-3 py-2 text-sm', className)}
    >
      <span className="font-semibold">{t('instruments.lotsForm.fields.notes')}: </span>
      <div
        className={cn(RICH_TEXT_DISPLAY_CLASSNAME, 'inline-block align-top [&_p]:my-0')}
        dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(notesHtmlSource) }}
      />
    </div>
  )
}
